import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import founder from '../assets/profile photos/pushkar.png'
import emp1 from '../assets/profile photos/pragatiNew.png'
import emp2 from '../assets/profile photos/pranjali.png'
import emp3 from '../assets/profile photos/somya.png'
import emp4 from '../assets/profile photos/utu.png'



const AboutUs = () => {
  
  const people = [
    {
      name: "Pushkar Shah",
      role: "Founder",
      img: founder,
      linkedin: "https://www.linkedin.com/in/pushkar-shah-545b6069/",
      instagram: "https://www.instagram.com/pushkarshah.01/",
      twitter: "https://x.com/pushkarshah01",
      portfolio: ""

    },
    {
      name: "Pragati Kulkarni",
      role: "Web Developer",
      img: emp1,
      linkedin: "https://www.linkedin.com/in/pragati-kulkarni-sde/",
      instagram: "https://www.instagram.com/pragatikulkarni",
      twitter: "",
      portfolio: "https://pragati-kulkarni-portfolio.netlify.app/"

    },
    {
      name: "Pranjali Jagtap",
      role: "Web Developer",
      img: emp2,
      linkedin: "https://www.linkedin.com/in/pranjali-jagtap-010313258/",
      instagram: "https://www.instagram.com/jagtappranjal123/",
      twitter: "https://x.com/pranjalijagta14",
      portfolio: "https://effulgent-axolotl-8a80fd.netlify.app/"

    },
    {
      name: "Somesh Chakele",
      role: "Web Developer",
      img: emp3,
      linkedin: "https://www.linkedin.com/in/somesh-chakele-59996a23b/",
      instagram: "https://www.instagram.com/im_bunny._.17/",
      twitter: "https://x.com/ChakeleSomesh",
      portfolio: "https://someshchakele.netlify.app/"
    },
    {
      name: "Utkarsh Kaule",
      role: "Web Developer",
      img: emp4,
      linkedin: "https://www.linkedin.com/in/utkarsh-kaule-100885222/",
      instagram: "https://www.instagram.com/utkarsh_bug/",
      twitter: "https://x.com/Utkarsh_Kaule",
      portfolio: "https://utkarsh-kaule-portfolio.netlify.app/"

    },
  ];

  return (
    <section className="py-24 sm:h-screen" id="about">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h2 className="font-manrope text-5xl text-center font-bold">
            Our team
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2  md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8 max-w-xl mx-auto md:max-w-3xl lg:max-w-full">
          {people.map((person, index) => (
      <a target="_blank" href={person.portfolio}>
            <div
              key={index}
              className="pt-3 pb-3 block group bg-white shadow-lg hover:shadow-2xl transition-shadow duration-300 rounded-lg"
            >
              <div className="relative mb-6">
                <img
                  src={person.img}
                  alt={`${person.name} image`}
                  className="w-20 h-20 rounded-full mx-auto transition-all duration-500 object-cover border border-solid border-transparent group-hover:border-indigo-600 "
                />
              </div>
              <h4 className="text-md font-semibold text-gray-900 mb-1 capitalize text-center transition-all duration-500 group-hover:text-indigo-600">
                {person.name}
              </h4>
              <span className="text-gray-500 text-center block transition-all duration-500 group-hover:text-gray-900">
                {person.role}
              </span>
              <div className="mt-2 flex justify-center space-x-4">
                <a
                  href={person.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800"
                >
                  <FontAwesomeIcon icon={faLinkedin} size="1x" />
                </a>
                <a
                  href={person.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-pink-500 hover:text-pink-700"
                >
                  <FontAwesomeIcon icon={faInstagram} size="1x" />
                </a>
                <a
                  href={person.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-blue-600"
                >
                  <FontAwesomeIcon icon={faTwitter} size="1x" />
                </a>
              </div>
            </div>
    </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
